document.addEventListener('DOMContentLoaded', () => {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (isMobile) {
        let imagesWrap = document.querySelectorAll('.main-image-wrapper .main_img_wrapper');
        const sliderBg = document.querySelector('.new_slider-bg');
        const sliderNav = document.querySelector('.new_slider-nav');

        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.9
        };

        let lastActiveEntry = null;
        let bullets = [];

      const updateSlider_ = () => {
      const thumbnails = document.querySelectorAll('.thumbnail');
      
      const bgImageUrl = sliderBg.style.backgroundImage.slice(5, -2).replace(/^(https?:)?\/\/[^/]+/, "");
      
      // console.log("bg:", bgImageUrl); 
      
      thumbnails.forEach((thumb) => {
      const thumbImageUrl = thumb.src.replace(/^(https?:)?\/\/[^/]+/, "");
      
      thumb.classList.toggle('active', thumbImageUrl === bgImageUrl);
      });
      };

        const initializeSlider = () => {
            sliderNav.innerHTML = '';
            bullets = [];
            observer.disconnect();

            const visibleImages = Array.from(imagesWrap).filter(image => {
                return window.getComputedStyle(image).display !== 'none';
            });
            visibleImages.forEach((image, index) => {
                image.dataset.number = index;
                observer.observe(image);

                const bullet = document.createElement('div');
                bullet.classList.add('bullet');
                bullet.setAttribute('data-dots', index);
                sliderNav.appendChild(bullet);
                bullets.push(bullet);
            });

            if (visibleImages.length > 0) {
                const firstImage = visibleImages[0].querySelector('img');
                if (firstImage) {
                    const firstImgSrc = firstImage.getAttribute('src');
                    sliderBg.style.backgroundImage = `url(${firstImgSrc})`;
                    sliderBg.style.opacity = '1';
                    visibleImages[0].classList.add('active-img');
                    bullets[0].classList.add('active-cnav');
                    lastActiveEntry = visibleImages[0];
                }
            }

            setTimeout(updateSlider_, 100); 
        };

        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const img = entry.target.querySelector('img');
                    if (img) {
                        const imgSrc = img.getAttribute('src');
                        sliderBg.style.backgroundImage = `url(${imgSrc})`;
                        sliderBg.style.opacity = '1';
                    }

                    if (lastActiveEntry && lastActiveEntry !== entry.target) {
                        lastActiveEntry.classList.remove('active-img');
                        bullets[lastActiveEntry.dataset.number].classList.remove('active-cnav');
                    }

                    entry.target.classList.add('active-img');
                    bullets[entry.target.dataset.number].classList.add('active-cnav');
                    lastActiveEntry = entry.target;

                    updateSlider_();
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        initializeSlider();

        const mutationObserver = new MutationObserver(() => {
            updateSlider_();
        });

        mutationObserver.observe(document.querySelector('.product-slider .main-image'), { 
            childList: true, 
            subtree: true, 
            attributes: true, 
            attributeFilter: ['style'] 
        });
    }
});
